/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.orders.requests.modals.scheduleEvent.controllers', [
  'acme.common.service.userPreferences',
  'acme.common.service.api',
  'acme.common.service.validate',
  'acme.common.service.calendar',
  'acme.common.service.permissions'
])

.controller('OrdersRequestsModalsScheduleEventController', ['$scope', '$uibModalInstance', '$state', 'SelectedEvents', 'OrderRequestId', 'IsTemplate', 'UserPreferencesService', 'ApiService', 'CalendarService', 'ValidateService', 'PermissionsService', function($scope, $uibModalInstance, $state, SelectedEvents, OrderRequestId, IsTemplate, UserPreferencesService, ApiService, CalendarService, ValidateService, PermissionsService) {

    $scope.ordersRequestsModalsScheduleEvent = {

      dateFormats: UserPreferencesService.getDateFormat('extendedDate', 'dateFormat'),
      hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

      selectedEvents: [],

      currentEvent: {},
      currentEventTemplate: {},
      currentEventInstance: {},
      currentEventIndex: 0,

      createdEvents: [],

      // selectedScheduleTime: new Date(),

      defaultSchedule: {
        startDate: new Date(),
        duration: {
          hour: 1,
          minutes: 0
        }
      },

      currentSchedule: {
        startDate: new Date(),
        duration: {
          hour: 1,
          minutes: 0
        }
      },

      isSubmitted: false,
      isSaving: false,

      errors: [],
      hasPriceError: false,

      init: function() {
        if (SelectedEvents instanceof Array && SelectedEvents.length) {
          this.selectedEvents = SelectedEvents;
          this.showEvent(this.currentEventIndex);
        }
      },

      showEvent: function(index) {
        this.currentEvent = this.selectedEvents[index];

        this.currentSchedule = this.defaultSchedule;
        this.currentSchedule.startDate.setDate(this.currentSchedule.startDate.getDate()+1);
        this.currentSchedule.startDate.setHours(9);
        this.currentSchedule.startDate.setMinutes(0);

        this.getCurrentEventDetails();

      },

      getCurrentEventName: function() {
        return this.currentEventTemplate.name || this.currentEvent.eventName;
      },

      getCurrentEventDetails: function() {
        if (!IsTemplate) {
          this.getEvent();
        } else {
          this.getEventTemplate();
        }
      },

      getEvent: function() {
        ApiService.program.instances.detail(this.currentEvent.eventId).then(this.success.getEvent, this.error.getEvent);
      },

      getEventTemplate: function() {
        ApiService.program.get(this.currentEvent.eventTemplateId, true).then(this.success.getEventTemplate, this.error.getEventTemplate);
      },

      updateStartTime: function() {
        if (this.currentSchedule.startDate) {
          // this.currentSchedule.formattedStartTime = $filter('date')(this.currentSchedule.startDate, UserPreferencesService.getDateFormat('standardTime', 'hourFormat'));
          this.currentSchedule.startTime = CalendarService.toISO8601(this.currentSchedule.startDate, true);
        }
      },

      isValid: function() {
        return this.isValidDate() && this.isValidTime() && this.isValidDuration() && this.isValidPriceList();
      },

      isValidPriceList: function() {
        var r = true;
        if (IsTemplate && !(this.currentEventTemplate.priceLists instanceof Array && this.currentEventTemplate.priceLists.length)) {
          r = false;
          this.hasPriceError = true;
          this.isSaving = false;
        }
        return r;
      },
      
      isValidDate: function() {
        return (this.currentSchedule.startDate);
      },
      
      isValidTime: function() {
        var validators, r = true;
        if (this.isSubmitted) {
          validators = [
            {
              field: 'orders-requests-modals-schedule-event-hours',
              greater: {
                message: 'Please enter valid duration hour',
                test: function() {
                  var date = $scope.ordersRequestsModalsScheduleEvent.currentSchedule.startDate,
                      greater = date ? parseInt($scope.ordersRequestsModalsScheduleEvent.currentSchedule.startDate.getHours(), 10) : -2;
                  return {
                    greater: greater,
                    less: -1
                  };
                }
              }
            },
            {
              field: 'orders-requests-modals-schedule-event-minutes',
              greater: {
                message: 'Please enter valid duration minutes',
                test: function() {
                  var date = $scope.ordersRequestsModalsScheduleEvent.currentSchedule.startDate,
                      greater = date ? parseInt($scope.ordersRequestsModalsScheduleEvent.currentSchedule.startDate.getMinutes(), 10) : -2;
                  return {
                    greater: greater,
                    less: -1
                  };
                }
              }
            }
          ];
          r = ValidateService.validate(validators);
        }
        return r;
      },
      
      isValidDuration: function() {
        var validators, r = true;
        if (this.isSubmitted) {
          validators = [
            {
              field: 'orders-requests-modals-schedule-event-duration-hr-min',
              greater: {
                message: 'Please enter valid duration hour',
                test: function() {
                  var greater = parseInt($scope.ordersRequestsModalsScheduleEvent.currentSchedule.duration.hour, 10);
                  return {
                    greater: greater,
                    less: -1
                  };
                }
              }
            },
            {
              field: 'orders-requests-modals-schedule-event-duration-m-min',
              greater: {
                message: 'Please enter valid duration minutes',
                test: function() {
                  var greater = parseInt($scope.ordersRequestsModalsScheduleEvent.currentSchedule.duration.hour, 10);
                  return {
                    greater: greater,
                    less: -1
                  };
                }
              }
            },
            {
              field: 'orders-requests-modals-schedule-event-duration-total',
              greater: {
                message: 'Events must be 1 minute or longer',
                test: function() {
                  return {
                    greater: parseInt($scope.ordersRequestsModalsScheduleEvent.currentSchedule.duration.hour, 10) + parseInt($scope.ordersRequestsModalsScheduleEvent.currentSchedule.duration.minutes, 10),
                    less: 0
                  };
                }
              }
            }
          ];
          r = ValidateService.validate(validators);
        }
        return r;
      },

      getCapacityForEvent: function(event) {
        var capacity = 0,
            item,
            ticketQuantity,
            i, ii;
        if (event && event.hasOwnProperty('orderRequestItemSummary') && event.orderRequestItemSummary) {
          if (event.orderRequestItemSummary.itemDetails instanceof Array) {
            for (i=0, ii=event.orderRequestItemSummary.itemDetails.length; i < ii; i++) {
              item = event.orderRequestItemSummary.itemDetails[i];
              if (!item.isAddon && !item.addon) {
                ticketQuantity = parseInt(item.quantity, 10);
                if (!isNaN(ticketQuantity)) {
                  capacity = capacity + ticketQuantity;
                }
              }
            }
          }
        }
        return capacity;
      },

      processScheduledEvents: function() {
        var i, ii,
            j, jj,
            props,
            startTime,
            endTime;
        if (this.currentSchedule && this.currentSchedule.startDate) {

          startTime = this.currentSchedule.startDate;

          endTime = new Date ( startTime.getTime() + (this.currentSchedule.duration.hour * 60 * 60 * 1000) + (this.currentSchedule.duration.minutes * 60 * 1000) );

          //This is a template, so create a new event with the specified time
          if (IsTemplate) {
            props = this.currentEventTemplate;
            props.priceList = this.currentEventTemplate.priceLists[0];

            if (props.priceList && props.priceList.prices instanceof Array) {
              for (i=0,ii=props.priceList.prices.length;i<ii;i++) {
                for (j=0,jj=props.priceList.prices[i].salesChannels.length;j<jj;j++) {
                  if (props.priceList.prices[i].salesChannels[j].channel === 'manualEntry' ||
                    props.priceList.prices[i].salesChannels[j].channel === 'customerRep' ||
                    props.priceList.prices[i].salesChannels[j].channel === 'reseller') {
                    props.priceList.prices[i].salesChannels[j].enabled = true;
                  } else {
                    props.priceList.prices[i].salesChannels[j].enabled = false;
                  }
                }
              }
            }

            props.startTime = startTime;
            props.endTime = endTime;
            props.colorCategory = this.currentEvent.eventColorCategory;
            props.capacity = this.getCapacityForEvent(this.currentEvent);
            props.orderRequestId = OrderRequestId;

            ApiService.event.createOffSchedule(props).then(function (response) {
              var self = $scope.ordersRequestsModalsScheduleEvent;
              self.currentEvent.eventId = response.data.payload.id;
              self.currentEvent.eventName = response.data.payload.name;
              self.currentEvent.eventStartDate = response.data.payload.startTime;
              self.currentEvent.customFields = response.data.payload.customFields || [];
              self.successClose(self.currentEvent);
            }, this.error.createOffSchedule);
          } else {
            //This is an event, so update the time
            this.currentEventInstance.startTime = startTime;
            this.currentEventInstance.endTime = endTime;
            
            if (this.currentEventInstance.orderRequestId) {
              this.currentEventInstance.orderRequestId = OrderRequestId;
            }

            ApiService.event.updateOffSchedule(this.currentEventInstance).then(function(response) {
              var self = $scope.ordersRequestsModalsScheduleEvent;
              self.currentEvent.eventStartDate = response.data.payload.startTime;
              self.currentEvent.customFields = response.data.payload.customFields || [];
              self.successClose(self.currentEvent);
              self.isSaving = false;
            }, this.error.updateOffSchedule);
          }
        }
      },

      getOrderItemRequestFromEvent: function(event) {
        var orderRequestItem = {
            eventStartDate: event.eventStartDate,
            eventTemplateId: event.eventTemplateId,
            eventTemplateName: event.eventTemplateName,
            orderRequestItemSummary: event.orderRequestItemSummary,
            externalReferenceId: event.externalReferenceId || '',
            orderItemType: 'Event',
            customFields: event.customFields || []
          };

        if (event.id) {
          orderRequestItem.id = event.id;
        }
        if (event.eventId) {
          orderRequestItem.eventId = event.eventId;
        }
        if (event.eventName) {
          orderRequestItem.eventName = event.eventName;
        }
        if (event.orderNumber) {
          orderRequestItem.orderNumber = event.orderNumber;
        }
        if (event.orderId) {
          orderRequestItem.orderId = event.orderId;
        }

        return orderRequestItem;
      },

      success: {
        getEventTemplate: function(response){
          var self = $scope.ordersRequestsModalsScheduleEvent;
          self.currentEventTemplate = response.data.payload;
          self.isValidPriceList();
        },
        getEvent: function(response){
          var startDate,
              endDate,
              self = $scope.ordersRequestsModalsScheduleEvent,

              duration = {
                hour: 0,
                minutes: 0
              };

          self.currentEventInstance = response.data.payload;
          startDate = CalendarService.parseDate(self.currentEventInstance.startTime);
          endDate = CalendarService.parseDate(self.currentEventInstance.endTime);

          if (!isNaN(startDate.getHours())) {
            // self.selectedScheduleTime = CalendarService.militaryTimeToDate( startDate.getHours() + ":" + startDate.getMinutes() );
            if (!isNaN(endDate.getHours())) {
              duration = CalendarService.dateRangeToDuration(startDate, endDate);
            }
            self.currentSchedule = {
              startDate: startDate,
              duration: {
                hour: duration.hour,
                minutes: duration.minutes
              }
            };
          }
        },
        createOffSchedule: function(response) {}
      },

      error: {
        getEventTemplate: function(response){
          var errorMsg = (response && response.data.error) ? response.data.error : 'Something went wrong, please try again later.';
          $scope.ordersRequestsModalsScheduleEvent.errors = [{
            message: errorMsg
          }];
        },
        getEvent: function(response){
          var errorMsg = (response && response.data.error) ? response.data.error : 'Something went wrong, please try again later.';
          $scope.ordersRequestsModalsScheduleEvent.errors = [{
            message: errorMsg
          }];
        },
        createOffSchedule: function(response) {
          var errorMsg = (response && response.data.error) ? response.data.error : 'Something went wrong, please try again later.';
          $scope.ordersRequestsModalsScheduleEvent.errors = [{
            message: errorMsg
          }];
          $scope.ordersRequestsModalsScheduleEvent.isSaving = false;
        },
        updateOffSchedule: function(response) {
          var errorMsg = (response && response.data.error) ? response.data.error : 'Something went wrong, please try again later.';
          $scope.ordersRequestsModalsScheduleEvent.errors = [{
            message: errorMsg
          }];
          $scope.ordersRequestsModalsScheduleEvent.isSaving = false;
        }
      },

      done: function(dismiss) {
        if (dismiss) {
          this.cancel();
        }
        else {
          this.isSubmitted = true;
          this.isSaving = true;
          this.hasPriceError = false;
          if (this.isValid()) {
            this.processScheduledEvents();
          }else{
            this.isSaving = false;
          }
        }
      },

      goToEvent: function() {
        if (IsTemplate && PermissionsService.check('EVENT_TEMPLATE_UPDATE')) {
          $state.go('application.templates.edit.pricing', ({ id: this.currentEventTemplate.id}));
        } else if (PermissionsService.check('EVENT_UPDATE')) {
          $state.go('application.programsInstanceEdit', {id: this.currentEventInstance.id});
        }
        $uibModalInstance.dismiss('cancel');
      },

      successClose: function(event) {
        $uibModalInstance.close({event: event});
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      }

    };

    $scope.ordersRequestsModalsScheduleEvent.init();

}])
  .controller('ScheduleEventDatePickerController', ['$scope', '$timeout', 'UserPreferencesService',  function($scope, $timeout, UserPreferencesService) {
  $scope.scheduleEventsPicker = {

    isOpen: false,

    dateOptions: {
      formatYear: 'yy',
      startingDay: UserPreferencesService.getStartDayOfWeek(),
      formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
      showWeeks: false
    },

    isPreferenceLoaded: false,

    dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),

    init: function() {
      this.today();
      $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
      $scope.format = $scope.formats[1];
      $scope.minDate = this.getMinDate();
      $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
      $timeout(function () {
        $scope.scheduleEventsPicker.isPreferenceLoaded = true;
      },0);
    },

    today: function() {
      this.dt = new Date();
    },

    clear: function () {
      $scope.dt = null;
    },

    getMinDate: function() {

      var d = new Date();

      d.setMonth(0);
      d.setDate(1);

      return d;

    },

    open: function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.minDate = this.getMinDate();

      this.isOpen = !this.isOpen;
    },

    onDateFormatLoad: function (e, data) {
      var self = $scope.scheduleEventsPicker;
      self.dateFormat = UserPreferencesService.getDateFormat('fieldDate', 'dateFormat');
      self.dateOptions = {
        formatYear: 'yy',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat')
      };
    }

  };

  $scope.scheduleEventsPicker.init();
}]);